import {
  OmsCustomerTagConditionStep,
  OmsOrderTagConditionStep,
  OmsProductNameConditionStep,
  OmsProductTagConditionStep,
  OmsProductTypeConditionStep,
  OmsSelectedShippingConditionStep,
  OmsShipmentTagConditionStep,
  OmsSkuConditionStep,
  OmsVariantTitleConditionStep,
  OmsVendorConditionStep,
} from "@redotech/redo-flows-common/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-flows-common/steps";
import { memo } from "react";
import { DeepPartial } from "..";
import { RequireExactMatchInput } from "../common/require-exact-match-input";

export const OmsRequireExactMatchInput = memo(
  function OmsRequireExactMatchInput({
    step,
    setStep,
  }: {
    step:
      | DeepPartial<OmsOrderTagConditionStep>
      | DeepPartial<OmsSkuConditionStep>
      | DeepPartial<OmsSelectedShippingConditionStep>
      | DeepPartial<OmsProductNameConditionStep>
      | DeepPartial<OmsVariantTitleConditionStep>
      | DeepPartial<OmsProductTypeConditionStep>
      | DeepPartial<OmsProductTagConditionStep>
      | DeepPartial<OmsShipmentTagConditionStep>
      | DeepPartial<OmsVendorConditionStep>
      | DeepPartial<OmsCustomerTagConditionStep>;
    setStep: (step: DeepPartial<OmsConditionStep>) => void;
  }) {
    return (
      <RequireExactMatchInput
        onRequireExactMatchChange={(requireExactMatch) => {
          setStep({ ...step, requireExactMatch });
        }}
        requireExactMatch={step.requireExactMatch}
      />
    );
  },
);
